export enum RiskRegisterBulkDialogType {
    AssessmentStatus,
    MethodOfAssessment,
    RiskRegisterControls,
    HealthRiskScore,
    ConsequenceRating
}
